import {
  AddNewsType,
  Branch,
  EditNewsType,
  EditVacancyType,
  FaqEditType,
  FaqsRes,
  FaqType,
  ICandidateParams,
  ICandidateRes,
  INetworkConfig,
  IPagination,
  IResponse,
  ISuccessResponse,
  IVacanciesParams,
  IVacanciesRes,
  IVacancyType,
  NewsParams,
  NewsResponse,
  NewsType,
  OurTeamImage,
  OurTeamImagesRes,
  Position,
  PostType,
  VacancyPositionChange,
} from '@/types'
import { Endpoints } from '../endpoints'
import { Instance } from '../instance'

const config: INetworkConfig = {
  baseURL: Endpoints.Base,
}

class VacancyApi extends Instance {
  constructor(config: INetworkConfig) {
    super(config)
  }

  unTopNews = (id: number): Promise<IResponse<ISuccessResponse>> =>
    this.patch(`${Endpoints.Posts}/${id}${Endpoints.UnTop}`)

  toTopNews = (id: number): Promise<IResponse<ISuccessResponse>> =>
    this.patch(`${Endpoints.Posts}/${id}${Endpoints.Top}`)

  recommendNews = (id: number): Promise<IResponse<ISuccessResponse>> =>
    this.patch(`${Endpoints.Posts}/${id}${Endpoints.Recommend}`)

  unRecommendNews = (id: number): Promise<IResponse<ISuccessResponse>> =>
    this.patch(`${Endpoints.Posts}/${id}${Endpoints.UnRecommended}`)

  addToArchiveNews = (id: number): Promise<IResponse<ISuccessResponse>> =>
    this.patch(`${Endpoints.Posts}/${id}${Endpoints.Archive}`)

  addToUnArchiveNews = (id: number): Promise<IResponse<ISuccessResponse>> =>
    this.patch(`${Endpoints.Posts}/${id}${Endpoints.UnArchive}`)

  getSingleNews = (id: number): Promise<IResponse<NewsType>> => this.get(`${Endpoints.Posts}/${id}`)

  addNews = (params: AddNewsType): Promise<IResponse<ISuccessResponse>> =>
    this.post(`${Endpoints.Posts}/${params.status}/${PostType.News}`, params.data)

  editNews = (params: EditNewsType): Promise<IResponse<ISuccessResponse>> =>
    this.put(`${Endpoints.Posts}/${params.id}/${PostType.News}`, params.data)

  getTopNew = (): Promise<IResponse<NewsType>> => this.get(`${Endpoints.Posts}${Endpoints.Top}/${PostType.News}`)

  getRecommendNew = (): Promise<IResponse<NewsType>> =>
    this.get(`${Endpoints.Posts}${Endpoints.Recommend}/${PostType.News}`)

  getAllNews = (params: NewsParams): Promise<IResponse<NewsResponse>> =>
    this.get(`${Endpoints.AllPosts}/${params.status}/${PostType.News}`, { params })

  getOurTeamImages = (): Promise<IResponse<OurTeamImagesRes>> => this.get(Endpoints.OurTeamImagesAll)

  addTeamImage = (params: OurTeamImage): Promise<IResponse<ISuccessResponse>> =>
    this.post(Endpoints.OurTeamImage, params)

  changePositionImage = (params: Position): Promise<IResponse<ISuccessResponse>> =>
    this.patch(`${Endpoints.OurTeamImagePosition}/${params.id}`, params)

  deleteOurTeamImage = (id: number): Promise<IResponse<ISuccessResponse>> =>
    this.delete(`${Endpoints.OurTeamImage}/${id}`)

  getOurTeamFaqsAll = (params: IPagination): Promise<IResponse<FaqsRes>> =>
    this.get(Endpoints.OurTeamFaqsAll, { params })

  addOurTeamFaq = (params: FaqType): Promise<IResponse<ISuccessResponse>> => this.post(Endpoints.OurTeamFaq, params)

  changePositionFaq = (params: Position): Promise<IResponse<ISuccessResponse>> =>
    this.patch(`${Endpoints.OurTeamFaqPosition}/${params.id}`, params)

  deleteOurTeamFaq = (id: number): Promise<IResponse<ISuccessResponse>> => this.delete(`${Endpoints.OurTeamFaq}/${id}`)

  editOurTeamFaq = (params: FaqEditType): Promise<IResponse<ISuccessResponse>> =>
    this.put(`${Endpoints.OurTeamFaq}/${params.id}`, params.data)

  getBranches = (): Promise<IResponse<Branch[]>> => this.get(Endpoints.Branches)

  getVacancyCandidates = (params: ICandidateParams): Promise<IResponse<ICandidateRes>> =>
    this.get(`${Endpoints.Vacancies}/${params.id}/${Endpoints.Candidates}`, { params })

  getVacancies = (params: IVacanciesParams): Promise<IResponse<IVacanciesRes>> =>
    this.get(Endpoints.VacanciesAll, { params })

  getSingleVacancy = (id: number): Promise<IResponse<IVacancyType>> => this.get(`${Endpoints.Vacancies}/${id}`)

  addVacancies = (params: IVacancyType): Promise<IResponse<ISuccessResponse>> => this.post(Endpoints.Vacancies, params)

  editVacancies = (params: EditVacancyType): Promise<IResponse<ISuccessResponse>> =>
    this.put(`${Endpoints.Vacancies}/${params.id}`, params.data)

  changePositionVacancy = (params: VacancyPositionChange): Promise<IResponse<ISuccessResponse>> =>
    this.patch(Endpoints.VacanciesPositions, params)

  addVacanciesArchive = (id: number): Promise<IResponse<ISuccessResponse>> =>
    this.patch(`${Endpoints.Vacancies}/${id}${Endpoints.Archive}`)

  addVacanciesUnArchive = (id: number): Promise<IResponse<ISuccessResponse>> =>
    this.patch(`${Endpoints.Vacancies}/${id}${Endpoints.UnArchive}`)
}

export const vacancyApi = new VacancyApi(config)
